<template>
	<div  style="width:100%;height:100%;position: absolute;top:0px;z-index: 100">
		<photo-slider ref="slider"  style="width:100%;height:100%;position: absolute;top:0px;z-index: 100"/>
	</div>
</template>

<script>

	import axios from 'axios';
	import PhotoSlider from './PhotoSlider';

	// const baseURL="https://d.hive.properties/default/slider/";
	// const baseURL = "http://localhost:5000/default/slider/";

	export default {
		name: "Home",
		components: {
			PhotoSlider
		},
		props:{
			baseURL:String
		},
		data() {
			return {
				sliderConf: null
			}
		},
		mounted() {
			axios
				.get(this.baseURL+'slider/' + 'conf.json')
				.then(response => {
					this.sliderConf = response.data;
					// console.log(response.data);
					this.$refs.slider.initData(this.baseURL+"slider/", response.data.groups);
				});
		}
	}
</script>

<style scoped>

</style>